/* eslint-disable operator-linebreak */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactResizeDetector from 'react-resize-detector';
import ViewportUnitsBuggyfill from 'viewport-units-buggyfill';
import 'babel-polyfill';

// components
import AppView from '../../components/App';

// actions
import { detectAppMobile, parseAppTTP } from '../../reducers/App/actions';

// helpers
import { SIDEBAR_CONTAINER } from '../../lib/Constants';

const AppPropTypes = {
  store: PropTypes.shape({
    // The application state
    dispatch: PropTypes.func,
    subscribe: PropTypes.func,
    getState: PropTypes.func,
    replaceReducer: PropTypes.func,
    Symbol: PropTypes.func,
  }).isRequired,
  dispatchDetectMobile: PropTypes.func.isRequired, // Method for checking if user is on mobile device
  isLoading: PropTypes.bool.isRequired, // True when the application is loading
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
};

const AppDefaultProps = {};

class App extends Component {
  constructor(props) {
    super(props);

    const { dispatchDetectMobile } = this.props;

    dispatchDetectMobile();

    this.onResize = this.onResize.bind(this);

    ViewportUnitsBuggyfill.init();
  }

  onResize() {
    const { isMobile, dispatchDetectMobile } = this.props;

    // hide scrollbar on older OS
    const sbContainer = document.getElementsByClassName(SIDEBAR_CONTAINER)[0];
    if (!isMobile) {
      const width =
        sbContainer.offsetWidth +
        (sbContainer.offsetWidth - sbContainer.clientWidth);
      if (width <= 385) sbContainer.style.width = `${width}px`;
    }

    dispatchDetectMobile();
  }

  render() {
    const { store, isLoading } = this.props;

    return (
      <div>
        {isLoading && <div className="section-loader app--loading" />}
        <AppView store={store} />
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={this.onResize}
        />
      </div>
    );
  }
}

App.propTypes = AppPropTypes;

App.defaultProps = AppDefaultProps;

const mapDispatchToProps = dispatch => ({
  dispatchDetectMobile: () => {
    dispatch(detectAppMobile());
  },
});

const mapStateToProps = state => ({
  isLoading: state.App.isLoading,
  isMobile: state.App.isMobile,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);
